var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5087 68.1359C57.3134 66.6969 59.5544 65.9153 61.8626 65.9199C64.1709 65.9246 66.4087 66.7151 68.2077 68.1613",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8582 76.0957H61.8839",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58.3171C38.9998 57.5782 39.1609 56.8481 39.4719 56.1778C39.7829 55.5076 40.2364 54.9132 40.8007 54.4363L58.5793 39.2C59.4962 38.4251 60.6578 38 61.8582 38C63.0586 38 64.2203 38.4251 65.1371 39.2L82.9157 54.4363C83.48 54.9132 83.9335 55.5076 84.2445 56.1778C84.5555 56.8481 84.7166 57.5782 84.7164 58.3171V81.1753C84.7164 82.5225 84.1812 83.8145 83.2286 84.7671C82.276 85.7197 80.984 86.2549 79.6368 86.2549H44.0796C42.7324 86.2549 41.4404 85.7197 40.4878 84.7671C39.5352 83.8145 39 82.5225 39 81.1753V58.3171Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1592 60.232C52.7629 57.3467 57.2417 55.7747 61.8582 55.7747C66.4746 55.7747 70.9535 57.3467 74.5572 60.232",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs8);
export default __webpack_public_path__ + "static/media/IconFaqs8.a31293443f31cc5424b151ff9c111643.svg";
export { ForwardRef as ReactComponent };